var _circle, _path, _path2, _circle2, _path3, _circle3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelpfulIcon = function SvgHelpfulIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.547,
    cy: 18.875,
    r: 16.475,
    fill: "#E9FEF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6ED9C5",
    d: "M7.54 30.92c1.03-5.65 6.855-7.315 9.638-7.442h.644c1.992 0 4.228 1.133 5.098 1.699-.961 2.93.712 5.79 1.67 6.855-6.114 1.983-11.66 2.666-17.05-1.113Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M33.224 21.246c.283-1.208.432-2.467.432-3.761 0-9.1-7.377-16.476-16.477-16.476C8.08 1.009.703 8.385.703 17.485c0 9.1 7.377 16.476 16.476 16.476 2.76 0 5.362-.678 7.647-1.878"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.181,
    cy: 15.079,
    r: 5.734,
    fill: "#FFBE00",
    stroke: "#1A1E22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M22.804 25.198a9.753 9.753 0 0 0-5.625-1.775c-4.735 0-8.686 3.36-9.599 7.824"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.426,
    cy: 26.998,
    r: 6.848,
    fill: "#E9FEF5",
    stroke: "#1A1E22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D7C54",
    d: "m26.715 26.775 1.95 1.98 3.782-3.961"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelpfulIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "helpful-icon.53865a0d4410b729b037c9f33d34e65f.svg";